
const navigation = {
  home: 'Accueil',
  sugar: 'Sucre',
  coffee: 'Café',
  logistics: 'Logistique',
  news: 'Actualités',
  contact: 'Contact'
};

const hero = {
  title: 'Exportation de Matières Premières',
  subtitle: 'Sucre et Café du Brésil vers le Monde',
  description: 'Le Brésil est leader mondial dans la production et l\'exportation de sucre et de café. Ce site présente un panorama complet de ces produits, leurs marchés, la logistique d\'exportation et bien plus.',
  exploreSugar: 'Explorer le Sucre',
  discoverCoffee: 'Découvrir le Café'
};

const features = {
  title: 'Explorez Nos Sections',
  description: 'Découvrez des informations détaillées sur les processus, marchés et logistique des principales matières premières brésiliennes',
  sugar: {
    title: 'Apprenez le processus d\'exportation du sucre',
    description: 'Du champ au port : comprenez comment le sucre brésilien atteint les marchés internationaux'
  },
  coffee: {
    title: 'Découvrez les chemins du café brésilien',
    description: 'Tradition et qualité qui font du Brésil le plus grand exportateur mondial de café'
  },
  logistics: {
    title: 'Comprenez la logistique et les navires de fret',
    description: 'L\'infrastructure portuaire et de transport qui rend possible les exportations'
  },
  learnMore: 'En Savoir Plus'
};

const stats = {
  title: 'Le Brésil en Chiffres',
  description: 'Données démontrant l\'importance du Brésil sur le marché mondial des matières premières',
  sugarExport: 'Du sucre produit est exporté',
  coffeeWorld: 'Du café mondial vient du Brésil',
  mainPorts: 'Principaux ports exportateurs',
  countries: 'Pays de destination'
};

const cta = {
  title: 'Restez Informé',
  description: 'Suivez les dernières tendances du marché des matières premières et les actualités du secteur',
  seeNews: 'Voir les Actualités',
  contact: 'Prendre Contact'
};

// Sugar page translations
const sugar = {
  hero: {
    title: 'Sucre Brésilien',
    subtitle: 'Du Champ au Port'
  },
  types: {
    title: 'Types de Sucre Exportés',
    vhp: {
      name: 'VHP (Very High Polarization)',
      description: 'Sucre brut à haute polarisation, idéal pour le raffinage'
    },
    refined: {
      name: 'Raffiné',
      description: 'Sucre blanc raffiné, prêt à la consommation'
    },
    crystal: {
      name: 'Cristal',
      description: 'Sucre cristallisé, plus commun sur le marché intérieur'
    }
  },
  regions: {
    title: 'Principales Régions Productrices',
    sp: {
      name: 'São Paulo',
      production: '55%',
      description: 'Plus grande région productrice du pays'
    },
    mg: {
      name: 'Minas Gerais',
      production: '12%',
      description: 'Deuxième plus grande région productrice'
    },
    go: {
      name: 'Goiás',
      production: '10%',
      description: 'Région importante du Centre-Ouest'
    }
  },
  process: {
    title: 'Processus d\'Exportation',
    step1: {
      title: 'Récolte de la Canne à Sucre',
      description: 'Récolte mécanisée ou manuelle de la canne'
    },
    step2: {
      title: 'Traitement dans les Usines',
      description: 'Broyage et extraction du jus de canne'
    },
    step3: {
      title: 'Stockage et Transport',
      description: 'Stockage en silos et transport routier'
    },
    step4: {
      title: 'Embarquement dans les Ports',
      description: 'Chargement sur navires vraquiers'
    }
  },
  market: {
    title: 'Marché International',
    destinations: 'Principales Destinations',
    factors: {
      title: 'Facteurs Affectant les Prix',
      climate: {
        title: 'Conditions Climatiques :',
        description: 'Sécheresses ou pluies excessives affectent la production'
      },
      oil: {
        title: 'Prix du Pétrole :',
        description: 'Influence la production d\'éthanol comme alternative'
      },
      demand: {
        title: 'Demande Mondiale :',
        description: 'Croissance démographique et changements de consommation'
      },
      exchange: {
        title: 'Taux de Change :',
        description: 'Variation du dollar impacte la compétitivité'
      }
    }
  },
  curiosities: {
    title: 'Curiosités du Sucre Brésilien',
    exported: 'De la production brésilienne est exportée',
    worldShare: 'Du sucre mondial vient du Brésil',
    mills: 'Usines en fonctionnement dans le pays',
    hectares: 'Hectares de canne plantés',
    worldRank: 'Place mondiale en production',
    countries: 'Pays importent notre sucre'
  }
};

// Coffee page translations
const coffee = {
  hero: {
    title: 'Café du Brésil',
    subtitle: 'Tradition et Qualité Mondiale'
  },
  history: {
    title: 'Histoire et Importance Économique',
    worldProduction: 'Production Mondiale',
    jobs: 'Emplois Générés',
    exports: 'Exportations Annuelles',
    importers: 'Pays Importateurs'
  },
  types: {
    title: 'Types de Café Exportés',
    arabica: {
      name: 'Arabica',
      percentage: '75%',
      description: 'Café de haute qualité, saveur douce et aromatique',
      regions: 'Minas Gerais, São Paulo, Espírito Santo'
    },
    robusta: {
      name: 'Robusta (Conilon)',
      percentage: '25%',
      description: 'Café plus résistant, saveur forte et teneur en caféine plus élevée',
      regions: 'Espírito Santo, Rondônia, Bahia'
    }
  },
  states: {
    title: 'États Producteurs',
    mg: {
      name: 'Minas Gerais',
      production: '54%',
      specialty: 'Arabica de montagne'
    },
    es: {
      name: 'Espírito Santo',
      production: '23%',
      specialty: 'Conilon et Arabica'
    },
    sp: {
      name: 'São Paulo',
      production: '9%',
      specialty: 'Arabica traditionnel'
    },
    ba: {
      name: 'Bahia',
      production: '8%',
      specialty: 'Conilon et cafés spéciaux'
    }
  },
  process: {
    title: 'Processus d\'Exportation',
    step1: {
      title: 'Récolte',
      description: 'Manuelle (derriça) ou mécanique'
    },
    step2: {
      title: 'Séchage',
      description: 'Naturel sur patios ou artificiel'
    },
    step3: {
      title: 'Traitement',
      description: 'Décorticage et classification'
    },
    step4: {
      title: 'Stockage',
      description: 'En sacs ou conteneurs'
    },
    step5: {
      title: 'Exportation',
      description: 'Embarquement dans les ports'
    }
  },
  market: {
    title: 'Destinations et Consommation Mondiale',
    destinations: 'Principales Destinations',
    factors: {
      title: 'Facteurs de Marché',
      quotes: {
        title: 'Cotations Internationales :',
        description: 'Bourses de New York et Londres déterminent les prix'
      },
      climate: {
        title: 'Conditions Climatiques :',
        description: 'Gelées et sécheresses affectent significativement les prix'
      },
      quality: {
        title: 'Qualité :',
        description: 'Cafés spéciaux atteignent des prix premium'
      },
      logistics: {
        title: 'Logistique :',
        description: 'Coûts de transport influencent la compétitivité'
      }
    }
  },
  trends: {
    title: 'Tendances du Marché',
    specialty: {
      title: 'Cafés Spéciaux',
      description: 'Croissance de la demande pour cafés d\'origine unique et méthodes spéciales de préparation'
    },
    certifications: {
      title: 'Certifications',
      description: 'Certifications biologiques, Fair Trade et Rainforest Alliance'
    },
    sustainability: {
      title: 'Durabilité',
      description: 'Pratiques environnementalement responsables et socialement justes'
    }
  }
};

// Logistics page translations
const logistics = {
  hero: {
    title: 'Logistique et Transport',
    subtitle: 'L\'Infrastructure Derrière l\'Exportation'
  },
  ships: {
    title: 'Types de Navires de Fret',
    bulk: {
      name: 'Vraquiers (Bulk Carriers)',
      description: 'Navires spécialisés dans le transport de produits en vrac comme le sucre',
      capacity: '60 000 - 200 000 tonnes'
    },
    containers: {
      name: 'Conteneurs Secs',
      description: 'Transport de café en sacs et produits emballés',
      capacity: '1 000 - 20 000 EVP'
    },
    refrigerated: {
      name: 'Conteneurs Réfrigérés',
      description: 'Pour produits nécessitant un contrôle de température',
      capacity: '200 - 2 000 EVP'
    }
  },
  ports: {
    title: 'Principaux Ports Exportateurs',
    santos: {
      name: 'Port de Santos (SP)',
      description: 'Plus grand port d\'Amérique latine',
      products: 'Sucre, Café, Soja',
      capacity: '4,8 millions EVP/an'
    },
    paranagua: {
      name: 'Port de Paranaguá (PR)',
      description: 'Principal corridor d\'exportation du Sud',
      products: 'Sucre, Soja, Maïs',
      capacity: '1,2 million EVP/an'
    },
    vitoria: {
      name: 'Port de Vitória (ES)',
      description: 'Important pour minerai et café',
      products: 'Café, Sucre, Minerai',
      capacity: '800 mille EVP/an'
    },
    itaqui: {
      name: 'Port d\'Itaqui (MA)',
      description: 'Porte d\'entrée du Nord-Est',
      products: 'Sucre, Soja, Maïs',
      capacity: '600 mille EVP/an'
    }
  },
  storage: {
    title: 'Entrepôts et Dépôts',
    silos: {
      name: 'Silos Vraquiers',
      description: 'Stockage vertical pour sucre en vrac',
      capacity: '10 000 - 100 000 tonnes'
    },
    warehouses: {
      name: 'Dépôts Douaniers',
      description: 'Entrepôts pour produits en attente d\'exportation',
      capacity: '5 000 - 50 000 tonnes'
    },
    refrigerated: {
      name: 'Entrepôts Réfrigérés',
      description: 'Conservation de produits sensibles à la température',
      capacity: '1 000 - 20 000 tonnes'
    }
  },
  transport: {
    title: 'Transport Intérieur',
    modes: 'Modes de Transport',
    road: {
      name: 'Routier',
      percentage: '70%',
      description: 'Principal mode pour transport intérieur'
    },
    rail: {
      name: 'Ferroviaire',
      percentage: '25%',
      description: 'Usage croissant dans certaines régions'
    },
    waterway: {
      name: 'Fluvial',
      percentage: '5%',
      description: 'Utilisé dans des régions spécifiques'
    },
    characteristics: {
      title: 'Caractéristiques du Transport',
      distances: {
        title: 'Distances Moyennes',
        farm: 'Ferme → Entrepôt : 50-200 km',
        warehouse: 'Entrepôt → Port : 200-800 km',
        time: 'Temps moyen : 2-5 jours'
      },
      costs: {
        title: 'Coûts Logistiques',
        percent: 'Représentent 15-25% du prix final',
        fuel: 'Carburant : plus grand composant',
        tolls: 'Péages et taxes portuaires'
      },
      seasonality: {
        title: 'Saisonnalité',
        peak: 'Pic lors de la récolte (mai-sep)',
        demand: 'Plus grande demande de transport',
        increase: 'Augmentation des frets'
      }
    }
  },
  challenges: {
    title: 'Défis et Opportunités',
    infrastructure: {
      title: 'Infrastructure Portuaire',
      description: 'Besoin de modernisation et d\'expansion de la capacité'
    },
    costs: {
      title: 'Coûts Logistiques',
      description: 'Réduction des coûts de transport et stockage'
    },
    sustainability: {
      title: 'Durabilité',
      description: 'Mise en œuvre de pratiques environnementalement responsables'
    },
    digitalization: {
      title: 'Numérisation',
      description: 'Automatisation et contrôle numérique des processus'
    }
  },
  numbers: {
    title: 'Chiffres de la Logistique',
    tonnage: 'Tonnes manutentionnées/an',
    ports: 'Ports organisés',
    terminals: 'Terminaux privés',
    gdp: 'Coût logistique du PIB'
  }
};

// News page translations
const news = {
  hero: {
    title: 'Actualités et Tendances',
    subtitle: 'Que Se Passe-t-il sur le Marché d\'Exportation ?'
  },
  market: {
    title: 'Cotations en Temps Réel'
  },
  tabs: {
    recent: 'Actualités Récentes',
    analysis: 'Analyses',
    forecasts: 'Prévisions'
  },
  analysis: {
    title: 'Analyse de Marché',
    positive: {
      title: 'Facteurs Positifs',
      climate: 'Climat favorable pour prochaine récolte',
      demand: 'Demande internationale croissante',
      infrastructure: 'Améliorations de l\'infrastructure logistique'
    },
    challenges: {
      title: 'Défis',
      exchange: 'Volatilité du taux de change',
      competition: 'Concurrence internationale',
      costs: 'Coûts logistiques élevés'
    }
  },
  newsletter: {
    title: 'Restez Informé',
    description: 'Recevez des mises à jour hebdomadaires sur le marché des matières premières directement dans votre email',
    placeholder: 'Votre email',
    subscribe: 'S\'abonner'
  }
};

// Contact page translations
const contact = {
  hero: {
    title: 'À Propos du Projet',
    subtitle: 'Rencontrez notre équipe et contactez-nous'
  },
  about: {
    title: 'Qui Nous Sommes'
  },
  objectives: {
    title: 'Nos Objectifs',
    educational: {
      title: 'Éducatif',
      description: 'Éduquer sur les processus de production et d\'exportation des principales matières premières brésiliennes'
    },
    informative: {
      title: 'Informatif',
      description: 'Fournir des données mises à jour sur les marchés, prix et tendances du secteur'
    },
    connective: {
      title: 'Connectif',
      description: 'Connecter différents publics intéressés par l\'agrobusiness brésilien'
    }
  },
  team: {
    title: 'Notre Équipe'
  },
  sources: {
    title: 'Sources de Données',
    description: 'Nous utilisons exclusivement des données officielles d\'institutions reconnues pour garantir la précision et la fiabilité des informations présentées.'
  },
  form: {
    title: 'Contactez-nous',
    subtitle: 'Vous avez des questions, suggestions ou souhaitez contribuer ? Parlez-nous !',
    name: 'Nom Complet',
    email: 'Email',
    subject: 'Sujet',
    message: 'Message',
    send: 'Envoyer le Message',
    sending: 'Envoi...',
    success: 'Message envoyé avec succès ! Nous vous contacterons bientôt.',
    error: 'Erreur lors de l\'envoi du message. Veuillez réessayer.',
    selectSubject: 'Sélectionnez un sujet',
    subjects: {
      doubt: 'Question sur les données',
      suggestion: 'Suggestion d\'amélioration',
      contribution: 'Contribution avec données',
      partnership: 'Proposition de partenariat',
      press: 'Presse',
      other: 'Autre'
    },
    placeholder: {
      name: 'Votre nom complet',
      email: 'votre@email.com',
      message: 'Décrivez votre message (maximum 500 caractères)'
    },
    charRemaining: 'caractères restants'
  },
  social: {
    title: 'Suivez-nous',
    description: 'Suivez-nous sur les réseaux sociaux pour recevoir les dernières mises à jour sur le marché des matières premières'
  }
};

export default {
  navigation,
  hero,
  features,
  stats,
  cta,
  sugar,
  coffee,
  logistics,
  news,
  contact
};
